import {
  Button,
  Menu,
  MenuDivider,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
  mergeClasses,
} from "@fluentui/react-components";
import {
  getDocumentTypeDotClassName,
  useDocumentTypeTagStyles,
} from "./DocumentTypeTag.styles";
import { IDocumentTypeTagProps } from "./DocumentTypeTag.types";

export const DocumentTypeTag = ({
  documentType,
  options,
  onSelect,
  disabled = false,
}: IDocumentTypeTagProps): JSX.Element => {
  const styles = useDocumentTypeTagStyles();
  const selectedOption = options.find((option) => option.id === documentType);

  return (
    <Menu>
      <MenuTrigger disableButtonEnhancement>
        {selectedOption ? (
          <Button
            appearance="subtle"
            className={styles.pillButton}
            disabled={disabled}
            aria-label={`Document type: ${selectedOption.name}. Click to change.`}
          >
            <span
              className={mergeClasses(
                styles.dot,
                getDocumentTypeDotClassName(styles, selectedOption.id),
              )}
              aria-hidden="true"
            />
            {selectedOption.name}
          </Button>
        ) : (
          <Button
            appearance="subtle"
            className={styles.addTagButton}
            disabled={disabled}
            aria-label="Add document type tag"
          >
            + Tag
          </Button>
        )}
      </MenuTrigger>
      <MenuPopover>
        <MenuList>
          {options.map((option) => (
            <MenuItem
              key={option.id}
              icon={
                <span
                  className={mergeClasses(
                    styles.dot,
                    getDocumentTypeDotClassName(styles, option.id),
                  )}
                  aria-hidden="true"
                />
              }
              onClick={() => onSelect(option.id)}
            >
              {option.name}
            </MenuItem>
          ))}
          <MenuDivider />
          <MenuItem onClick={() => onSelect(null)}>Clear tag</MenuItem>
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};
